import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import api from "../lib/api";
import BrandLogo from "../components/BrandLogo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch { /* response is intentionally generic */ }
    setDone(true);
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl p-8 space-y-6 shadow-sm">
        <div className="flex items-center gap-2">
          <BrandLogo />
          <span className="font-heading font-bold text-lg text-slate-900">MatteusMx</span>
        </div>

        {done ? (
          <div className="space-y-4" data-testid="forgot-confirmation">
            <div className="h-11 w-11 rounded-full bg-emerald-50 flex items-center justify-center">
              <MailCheck className="h-5 w-5 text-emerald-600" />
            </div>
            <h1 className="font-heading text-xl font-bold text-slate-900">Check your email</h1>
            <p className="text-sm text-slate-500 leading-relaxed">
              If <span className="font-medium text-slate-700">{email}</span> is registered — as a customer or store staff account — a password reset link has been sent. The link expires in 1 hour and can be used once.
            </p>
            <Link to="/">
              <Button variant="outline" className="w-full" data-testid="forgot-back-home-btn">
                <ArrowLeft className="h-4 w-4 mr-1.5" /> Back to MatteusMx
              </Button>
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <h1 className="font-heading text-xl font-bold text-slate-900">Forgot password</h1>
              <p className="text-sm text-slate-500">Enter the email on your customer or store staff account. We will email you a secure reset link.</p>
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="fp-email">Email</Label>
              <Input id="fp-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com" required className="h-11" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" className="w-full h-11 bg-slate-900 hover:bg-slate-800" disabled={busy} data-testid="forgot-submit-btn">
              {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Send reset link
            </Button>
            <p className="text-center">
              <Link to="/" className="text-xs font-medium text-slate-500 hover:text-slate-900 hover:underline" data-testid="forgot-back-login-link">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
